module.exports = __webpack_public_path__ + "static/media/town_fridge.131494da.png";